import {
  getPressuresList,
  getPressuresExportList,
  postUpdateAddAllExport,
  getExportModel,
  getPressuresListByMod
} from "./services";
import * as types from "./types";

export async function getPressuresListByModAction({ commit },payload) {
  try {
    return (await getPressuresListByMod(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getPressuresListAction({ commit }) {
  try {
    return (await getPressuresList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getPressuresExportListAction({ commit }) {
  try {
    return (await getPressuresExportList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function postUpdateAddAllExportAction({ commit }, payload) {
  try {
    return (await postUpdateAddAllExport(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function setAvaiablePressAction({ commit }, payload) {
  try {
    commit(types.SET_AVAIABLE_PRESS, payload);
  } catch (e) {
    console.log(e);
  }
}
export async function getExportModelAction({ commit }) {
  try {
    return (await getExportModel()).data;
  } catch (e) {
    console.log(e);
  }
}
